import { render } from "./AllRecipientsBadge.vue?vue&type=template&id=69c84262"
import script from "./AllRecipientsBadge.vue?vue&type=script&lang=js"
export * from "./AllRecipientsBadge.vue?vue&type=script&lang=js"
script.render = render

export default script